// extracted by mini-css-extract-plugin
export default {"card":"Chart_card__hW1k8","cardInfo":"Chart_cardInfo__n1Z9J","text":"Chart_text__hoZGs"};